/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { setFlow, resetFlow, FLOW_STORAGE_KEY } from "../slices/flowSlice";

export const flowMiddleware = (store) => (next) => (action) => {
  if (action.type === setFlow.type) {
    sessionStorage.setItem(FLOW_STORAGE_KEY, action.payload);
  }

  if (action.type === resetFlow.type) {
    sessionStorage.removeItem(FLOW_STORAGE_KEY);
  }

  return next(action);
};
